import { c as __rest, _ as __assign } from './tslib.es6-86dc5b0c.js';
import { jsx } from 'react/jsx-runtime';
import { I as InputBox } from './InputBox-01bcc484.js';

// Cleave must be imported using a `require`, as of 1.6.0
/* eslint-disable-next-line @typescript-eslint/no-var-requires */
var Cleave = require('cleave.js/react');
require('cleave.js/dist/addons/cleave-phone.us');
var TextBox = function (_a) {
    var _b;
    var cleaveOptions = _a.cleaveOptions, inputRef = _a.inputRef, _c = _a.isLoading, isLoading = _c === void 0 ? false : _c, _d = _a.isMultiline, isMultiline = _d === void 0 ? false : _d, _e = _a.isSuccessful, isSuccessful = _e === void 0 ? false : _e, textboxRef = _a.textboxRef, _f = _a.tooltipVertical, tooltipVertical = _f === void 0 ? 'top' : _f, _g = _a.value, value = _g === void 0 ? '' : _g, rest = __rest(_a, ["cleaveOptions", "inputRef", "isLoading", "isMultiline", "isSuccessful", "textboxRef", "tooltipVertical", "value"]);
    var sharedInputProps = __assign({ isLoading: isLoading, isSuccessful: isSuccessful, tooltipVertical: tooltipVertical, value: value }, rest);
    if (cleaveOptions && Object.keys(cleaveOptions).length > 0) {
        return (jsx(InputBox, __assign({ as: Cleave, htmlRef: function (ref) {
                if (inputRef) {
                    inputRef.current = ref;
                }
            }, options: cleaveOptions }, sharedInputProps), (_b = cleaveOptions.blocks) === null || _b === void 0 ? void 0 : _b.join('')));
    }
    if (isMultiline) {
        return jsx(InputBox, __assign({ as: "textarea", ref: textboxRef }, sharedInputProps), void 0);
    }
    return (jsx(InputBox, __assign({ as: "input", ref: textboxRef, type: "text" }, sharedInputProps), void 0));
};

export { TextBox as T };
